/* 客户产品管理-API */

import {post,get} from '../../libs/ajax.js'

export default {
    // 账户列表
    getCompanyList:(data,options) => {
        return get('/customer_app_manage_v2/get_company_list', data, options);
    },
    // 筛选条件-操作人下拉框列表
    getOperatorList:(data,options) => {
        return get('/customer_app_manage_v2/get_operator_list', data, options);
    },
   
    // 获取客户绑定列表
    getCustomerAppList:(data,options) => {
        return post('/customer_app_manage_v2/get_list', data, options);

    },
    // 未绑定客户产品LIST-产品搜索筛选下拉框数据
    postAppSelectList:(data,options) => {
        return post('/customer_app_manage_v2/get_app_select_list', data, options);
    },
    // 获取未绑定客户列表
    getUnbindAppList:(data,options) => {
        return get('/customer_app_manage_v2/unbind_app_list', data, options);
    },
    // 检查客户权限接口
    checkCustomer:(data,options) => {
        return get('/customer_app_manage_v2/check_customer', data, options);
    },
    // 停用
    disableCustomerApp:(data,options) => {
        return post('/customer_app_manage_v2/disable', data, options);

    },
    // 启用
    enableCustomerApp:(data,options) => {
        return post('/customer_app_manage_v2/enable', data, options);

    },
    // 获取绑定客户options列表
    getCompanySelector:(data,options) => {
        return get('/customer_app_manage_v2/get_company_selector', data, options);

    },
    // 未绑定产品-保存绑定
    saveUnbindApp:(data,options) => {
        return post('/customer_app_manage_v2/unbind_app_save', data, options);
    },
    // 选择绑定产品 - 搜索产品
    getBindApp:(data,options) => {
        return get('/customer_app_manage_v2/get_bind_app', data, options);
    },
    // 保存绑定
    bindAppSave:(data,options) => {
        return post('/customer_app_manage_v2/bind_app_save', data, options);
    },
    // 获取下拉列表
    getSearchList:(data,options) => {
        return post('/customer_app_manage_v2/get_search_list', data, options);
    },
    // 产品批量录入
    appEntryBatchAddApi:(data,options) => {
        return post('/customer_app_manage_v2/batch_add', data, options);
    },
    // 获取产品录入配置
    getAppEntryGetMap:(data,options) => {
        return get('/customer_app_manage_v2/get_map', data, options);
    },
    // 获取产品录入配置列表
    getAppEntryCnfigApi:(data,options) => {
        return get('/customer_app_manage_v2/get_config_list', data, options);
    },
    // 产品录入配置-校验
    getAppEntryValidation:(data,options) => {
        return get('/customer_app_manage_v2/get_validation_by_param', data, options);
    },
    // 获取字段名称
    getAppEntryGetFiled:(data,options) => {
        return get('/customer_app_manage_v2/get_field', data, options);
    },
    // 产品录入详情
    postAppEntryDetail:(data,options) => {
        return post('/customer_app_manage_v2/detail', data, options);
    },
    // 产品录入-编辑
    appEntryEditApi:(data,options) => {
        return post('/customer_app_manage_v2/edit', data, options);
    },
    // 获取产品录入 筛选字段
    getAppEntryField:(data, options) => {
        return get('/customer_app_manage_v2/get_search_field', data, options);
    },
    getEditUser:(data, options) => {
        return get('/customer_app_manage_v2/get_user', data, options);
    },
    editCreateUser:(data, options) => {
        return post('/customer_app_manage_v2/edit_create_user', data, options);
    }
}
